(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-slider]').forEach((slider) => {
      const track = slider.querySelector('.button-slider__track');
      const next = slider.querySelector('[data-next]');
      const prev = slider.querySelector('[data-prev]');

      const defaultScrollAmount = 700;
      const mobileQuery = window.matchMedia('(max-width: 749px)');

      const getGap = () => {
        const gapValue = getComputedStyle(track).gap;
        return gapValue ? parseFloat(gapValue) : 0;
      };

      const getScrollStep = () => {
        const firstItem = track.querySelector('.button-slider__item');
        if (!firstItem) return defaultScrollAmount;
        const gap = getGap();
        return Math.round(firstItem.getBoundingClientRect().width + gap);
      };

      let scrollAmount = defaultScrollAmount;

      const updateScrollAmount = () => {
        scrollAmount = mobileQuery.matches ? getScrollStep() : defaultScrollAmount;
      };

      function updateArrows() {
        const atStart = track.scrollLeft <= 0;
        const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
        prev.classList.toggle('is-disabled', atStart);
        next.classList.toggle('is-disabled', atEnd);
      }

      next.addEventListener('click', () => {
        track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });

      prev.addEventListener('click', () => {
        track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateArrows);
      updateScrollAmount();
      if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener('change', updateScrollAmount);
      } else if (mobileQuery.addListener) {
        mobileQuery.addListener(updateScrollAmount);
      }

      const wrapper = slider.closest('.button-slider__wrapper');
      const activeItem = track.querySelector('.button-slider__item.is-active');
      if (activeItem) {
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = Math.max(0, activeItem.offsetLeft - track.offsetWidth / 2 + activeItem.offsetWidth / 2);
        track.style.scrollBehavior = '';
      }
      wrapper.classList.add('is-ready');

      updateArrows();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections-cards"] && !Shopify.designMode) return;
  try {
    

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.collection-cards').forEach(section => {
      const buttons = section.querySelectorAll('.collection-cards__button');
      const images  = section.querySelectorAll('.collection-cards__image');

      buttons.forEach((button, index) => {
        const image = images[index];
        if (!image) return;

        const activate = () => {
          image.classList.add('is-hovered');
          button.classList.add('is-hovered');
        };

        const deactivate = () => {
          image.classList.remove('is-hovered');
          button.classList.remove('is-hovered');
        };

        button.addEventListener('mouseenter', activate);
        button.addEventListener('mouseleave', deactivate);
        image.addEventListener('mouseenter', activate);
        image.addEventListener('mouseleave', deactivate);
      });
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
    
  function initLookbookSwiper() {
    new Swiper('.lookbook-swiper', {
      speed: 600,
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      navigation: {
        nextEl: '.lookbook-next',
        prevEl: '.lookbook-prev'
      },
      on: {
        slideChange(swiper) {
          const current = document.querySelectorAll('[data-current]');
          if (current) {
            current.forEach((current) => {
              current.textContent = swiper.realIndex + 1;
            });
          }
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initLookbookSwiper);
  document.addEventListener('shopify:section:load', initLookbookSwiper);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  function initPushProduitsSwiper() {
    var container = document.querySelector('.push-produits__mobile-carousel');
    if (!container) return;
    var swiperEl = container.querySelector('.push-produits__swiper');
    if (!swiperEl || swiperEl.swiper) return;

    var counter = container.querySelector('.push-produits__mobile-counter');
    var total = container.querySelectorAll('.swiper-slide').length;

    new Swiper(swiperEl, {
      slidesPerView: 1.15,
      spaceBetween: 12,
      navigation: {
        prevEl: container.querySelector('.push-produits__nav-btn--prev'),
        nextEl: container.querySelector('.push-produits__nav-btn--next'),
      },
      on: {
        slideChange: function(swiper) {
          if (counter) {
            counter.textContent = (swiper.activeIndex + 1) + '/' + total;
          }
        }
      }
    });
  }

  // Init on load and after AJAX replacement (MutationObserver)
  document.addEventListener('DOMContentLoaded', initPushProduitsSwiper);
  document.addEventListener('shopify:section:load', initPushProduitsSwiper);

  // Re-init after product-recommendations AJAX replaces innerHTML
  var recoEl = document.querySelector('product-recommendations');
  if (recoEl) {
    new MutationObserver(function() {
      setTimeout(initPushProduitsSwiper, 100);
    }).observe(recoEl, { childList: true, subtree: true });
  }

  } catch(e) { console.error(e); }
})();
})();
